// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604281056/js/" + chunkId + "." + {"44":"73e7097d","225":"3fb13c2b","481":"bb54574b","486":"d39478fa","770":"c44f64a6"}[chunkId] + ".0.9384156857379864.chunk.js";
};